import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { imgProps } from "../lib/api";

export function ParallaxImage({ src, alt = "", className = "", sizes = "100vw", strength = 10, loading = "lazy", position = "center" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], [1, 1.05, 1.1]);
  return (
    <div ref={ref} className={`overflow-hidden ${className}`}>
      <motion.img
        {...imgProps(src, sizes)}
        alt={alt}
        loading={loading}
        style={{ y, scale, objectPosition: position }}
        className="absolute inset-0 h-[120%] w-full -top-[10%] object-cover will-change-transform"
      />
    </div>
  );
}
